import { KT_CHART_DISPLAY_ITEMS, buildKtChartValues } from './user-summary-chart.config';

export type UserDataEntry = {
  id?: string | null;
  asOfDate?: string | null;
  data?: Record<string, unknown> | null;
};

export type UserDataSelection = {
  primaryId: string | null;
  primaryDate: string | null;
  compareId: string | null;
  compareDate: string | null;
};

export const createInitialChartValues = (): number[] =>
  new Array(KT_CHART_DISPLAY_ITEMS.length).fill(0);

export function computeUserDataSelections(
  list: UserDataEntry[] | null | undefined,
  preferredDate?: string | null,
): UserDataSelection {
  if (!list?.length) {
    return {
      primaryId: null,
      primaryDate: null,
      compareId: null,
      compareDate: null,
    };
  }

  const normalizedPreferred = preferredDate ?? list[0]?.asOfDate ?? null;
  let primaryEntry =
    list.find(item => item?.asOfDate === normalizedPreferred) ?? list[0];
  if (!primaryEntry) {
    primaryEntry = list[0];
  }

  let compareEntry: UserDataEntry | null = null;
  for (let i = 0; i < list.length; i += 1) {
    const entry = list[i];
    if (
      entry?.asOfDate !== primaryEntry.asOfDate &&
      (!compareEntry ||
        new Date(entry.asOfDate ?? '').getTime() <
          new Date(compareEntry.asOfDate ?? '').getTime())
    ) {
      compareEntry = entry;
      break;
    }
  }

  return {
    primaryId: primaryEntry?.id ?? null,
    primaryDate: primaryEntry?.asOfDate ?? null,
    compareId: compareEntry?.id ?? null,
    compareDate: compareEntry?.asOfDate ?? null,
  };
}

export function computeChartValues(
  list: UserDataEntry[] | null | undefined,
  primaryId: string | null,
): number[] {
  const primaryEntry =
    list?.find(item => item?.id === primaryId) ?? list?.[0] ?? null;
  const data = (primaryEntry?.data as Record<string, unknown> | undefined) ?? {};
  return buildKtChartValues(key => data?.[key] as number | string | undefined);
}
